<template>
  <div class="handover-takeback">
    <div class="tms-dashboard__panel-header row">
      <div class="tms-dashboard__panel-container-without-button">
        <div class="tms-dashboard__panel-title-box">
          <div class="tms-dashboard__panel-title">
            {{ $t('currentHandoverTakeback') }}
            <i
              id="dashboard_refresh"
              class="fa fa-refresh dark flat icon_refresh"
              @click="loadHotbsWithQuery()"
            />
          </div>

          <div
            class="tms-dashboard__panel-view-all"
          >
            <router-link
              to="/tenant-projects"
            >
              {{ $t('viewAll') }} >
            </router-link>
          </div>
        </div>
        <div class="tms-dashboard__panel-toolbar">
          <div class="handover-takeback__counter">
            <div class="handover-takeback__counter--handover">
              <div class="handover-takeback__counter--number">
                {{ handoverCount }}
              </div>
              <span class="handover-takeback__counter--hint">{{ $t('handover.title') }}</span>
            </div>
            <div class="handover-takeback__counter--takeback">
              <span class="handover-takeback__counter--number"> {{ takebackCount }} </span>
              <span class="handover-takeback__counter--hint">{{ $t('takeback.title') }}</span>
            </div>
          </div>
          <div class="handover-takeback__counter--duration">
            <span>{{ $t('showLabel') }}:</span>
            <HKLSelect
              :options="timeHklOptions"
              placeholder=""
              :showSearch="false"
              :value="selectedTimeValue"
              @change="updateShowHandoverTakeback"
            />
          </div>
        </div>
      </div>
      <HKLButton
        color="darkblue"
        action="reset"
        class="tms-dashboard__panel-reset-btn"
        @click="resetFilter"
      />
    </div>
    <div class="handover-takeback__table">
      <table class="sort_table">
        <thead>
          <tr class="handover-takeback__table--header">
            <th
              v-for="(header, index) in tableHeaders"
              :key="index"
              :class="header.className"
              @click="sortTable(header)"
            >
              <span :class="header.attr === 'premises' ? 'placeholder' : ''">
                {{ header.name }}
                <i
                  v-if="sortingAttr === header.attr"
                  :class="[reverse ? 'triangle-down' : 'triangle-up']"
                />
              </span>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="hotb in sortedHotbs"
            :key="hotb.id"
            class="handover-takeback__table--body"
          >
            <td>
              {{ hotb.completedDate ? dateUtil.format(hotb.completedDate, 'DD MMM YY') : hotb.scheduledTransactionDate
                ? dateUtil.format(hotb.scheduledTransactionDate, 'DD MMM YY, HH:mm')
                : hotb.transactionDate
                  ? dateUtil.format(hotb.transactionDate, 'DD MMM YY')
                  : emptyValue }}
            </td>
            <td>{{ (hotb.type || emptyValue) | customTProjectTypeLabel }}</td>
            <td>{{ hotb.companyName || emptyValue }}</td>
            <td>{{ hotb.tradeName || emptyValue }}</td>
            <td>
              <div class="pin-box">
                <div class="pin-placeholder">
                  <div
                    v-if="hotb.showPin"
                    class="pin__bubble-orange"
                  >
                    <i
                      class="fa fa-thumb-tack"
                      aria-hidden="true"
                    />
                  </div>
                </div>
                <a
                  class="link_text"
                  @click.prevent="navToDetail(hotb)"
                >
                  {{ hotb.premises || emptyValue }}
                </a>
              </div>
            </td>
            <td>{{ (hotb.status || emptyValue) | customStatusLabel }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import lodash from 'lodash'
import { mapGetters, mapActions, mapState } from 'vuex'
import dateUtil from '@/utils/dateUtil'
import navigation from '@/utils/navigation'
import { aclHelper, tmsPermsTypes } from '@/utils/aclHelper'
import { hotbTypes } from '@/utils/locale'
import HKLButton from '@/controls/Button/HKLButton'
import HKLSelect from '@/controls/Select/HKLSelect'
import { getHotbCompanyName, getHotbTradeName, getHotbPremises } from '../hotb/utils'
import { timeOptions } from './consts'
import { hotbRecordShowsApproverPin } from './hook'

export default {
  name: 'DashboardHandoverTakeback',
  components: {
    HKLButton,
    HKLSelect,

  },
  data () {
    return {
      timeOptions,
      hotbs: [],
      emptyValue: '--',
      sortingAttr: null,
      reverse: false,
      dateUtil,
    }
  },
  computed: {
    ...mapGetters('hotb', ['lastDashboardDateFilterIndex']),
    ...mapGetters('user', ['currentUser']),
    ...mapGetters('dashboard', ['isHotbListStale']),
    ...mapState('dashboard', { getHotbInfo: 'hotbInfo' }),

    tableHeaders () {
      return [
        {
          name: this.$t('date').toUpperCase(),
          className: 'date',
          attr: 'date',
        },
        {
          name: this.$t('hotbType').toUpperCase(),
          className: 'type',
          attr: 'type',
        },
        {
          name: this.$t('company.basic.companyName').toUpperCase(),
          className: 'companyName',
          attr: 'companyName',
        },
        {
          name: this.$t('company.tenancyRecord.tradeName'),
          className: 'tradeName',
          attr: 'tradeName',
        },
        {
          name: this.$t('company.tenancyRecord.premises'),
          className: 'premises',
          attr: 'premises',
        },
        {
          name: this.$t('company.basic.status').toUpperCase(),
          className: 'hotbstatus',
          attr: 'status',
        },
      ]
    },
    parsedHotbs () {
      const result = this.hotbs.map((hotb) => {
        const showPin = hotbRecordShowsApproverPin(hotb, this.currentUser.id)
        return {
          scheduledTransactionDate: lodash.get(hotb, 'scheduledTransactionDate'),
          transactionDate: lodash.get(hotb, 'transactionDate'),
          completedDate: lodash.get(hotb, 'completedDate'),
          date: lodash.get(hotb, 'completedDate') || lodash.get(hotb, 'scheduledTransactionDate') || lodash.get(hotb, 'transactionDate'),
          type: lodash.get(hotb, 'type') === 'HANDOVER' ? 'Handover' : lodash.get(hotb, 'type') === 'TAKEBACK' ? 'Takeback' : lodash.get(hotb, 'type'),
          rawType: lodash.get(hotb, 'type'),
          companyName: getHotbCompanyName(hotb),
          tradeName: getHotbTradeName(hotb),
          premises: `(${lodash.get(hotb, 'tenancy.building.code')}) ${getHotbPremises(hotb) || this.emptyValue}`,
          status: lodash.get(hotb, 'status'),
          id: lodash.get(hotb, 'id'),
          showPin,
        }
      })
      return result
    },
    sortedHotbs () {
      let options = [
        this.parsedHotbs,
        ['showPin', 'date'],
        ['desc', 'asc'],
      ]
      if (this.sortingAttr) {
        options[1] = [this.sortingAttr]
        options[2] = [this.reverse ? 'desc' : 'asc']
      }
      return lodash.orderBy(...options)
    },
    handoverCount () {
      return this.sortedHotbs.filter((hotb) => hotb.rawType === hotbTypes.HANDOVER).length
    },
    takebackCount () {
      return this.sortedHotbs.filter((hotb) => hotb.rawType === hotbTypes.TAKEBACK).length
    },
    timeHklOptions () {
      return this.timeOptions.map(option => ({
        name: this.$options.filters.customTimeLabel(option),
        value: option.value,
      }))
    },
    selectedTimeValue () {
      return (this.timeOptions[this.lastDashboardDateFilterIndex] || {}).value
    },
  },
  async mounted () {
    await this.hydrateOrFetchHotbs()
  },
  activated () {
    this.hydrateOrFetchHotbs()
  },
  methods: {
    ...mapActions('hotb', ['setLastDashboardDateFilterIndex']),
    ...mapActions('dashboard', ['setSortedAttributes', 'loadHotbs']),

    async getHotbsScheduledBefore (value) {
      let query = ''
      if (value) {
        const today = moment().startOf('day')
        query = `scheduledAfter=${today}&scheduledBefore=${today + value}`
      }
      await this.getHotbs(query)
    },
    async updateShowHandoverTakeback (value) {
      await this.getHotbsScheduledBefore(value && Number(value))
      this.setLastDashboardDateFilterIndex({index: this.timeOptions.findIndex(rec => rec.value === value)})
    },
    navTo (name) {
      navigation.toPage(name)
    },
    /** Dashboard: open detail without list-navigation chrome (no Prev/Next / back-to-search — that stays on `/tenant-projects`). */
    navToDetail (item) {
      this.$store.dispatch('listNavigation/clearListNavigationSequence')
      navigation.toPage('handover', { id: item.id })
    },
    hasReadAccess () {
      return aclHelper.getAccess(tmsPermsTypes.hotb.read)
    },
    async getHotbs (query) {
      if (this.hasReadAccess()) {
        this.hotbs = await this.loadHotbs(query) || []
      }
    },
    sortTable (header) {
      if (this.sortingAttr === header.attr) {
        this.reverse = !this.reverse
      } else {
        this.sortingAttr = header.attr
      }
      this.setSortedToStore()
    },
    resetFilter () {
      this.sortingAttr = null
      this.reverse = false
      this.setSortedToStore()
    },
    setSortedToStore () {
      this.setSortedAttributes({sortedAttributes: {sortingAttr: this.sortingAttr, reverse: this.reverse}, dashboard: 'hotbInfo'})
    },
    async loadHotbsWithQuery () {
      const curOpt = this.timeOptions[this.lastDashboardDateFilterIndex]

      await this.getHotbsScheduledBefore(curOpt && curOpt.value)
    },
    async hydrateOrFetchHotbs () {
      const hotbListInStore = lodash.get(this.getHotbInfo, 'contentList') || []
      const sortedAttributes = lodash.get(this.getHotbInfo, 'sortedAttributes') || {}
      if (hotbListInStore.length && !this.isHotbListStale) {
        this.hotbs = hotbListInStore
      } else {
        await this.loadHotbsWithQuery()
      }
      const {sortingAttr, reverse} = sortedAttributes
      this.sortingAttr = sortingAttr || null
      this.reverse = reverse || false
    },
  },
}
</script>
<style lang="scss" scoped>
@import '~styles/components/hotb-list';
@import '~styles/dashboard/tenant';

.date {
  width: 12%;
}
.type {
  width: 10%;
}
.companyName {
  width: 18%;
}
.tradeName {
  width: 15%;
}
.premises {
  width: 35%;
}
.hotbstatus {
  width: 10%;
}
.placeholder {
  margin-left: 38px;
}
.pin-box {
  display: flex;
  align-items: center;
}
</style>
